import { MouseEvent, ReactNode } from "react";

interface IOwnProps {
    href: string;
    children: ReactNode;
}

const RenderLink = ({ href, children, ...props }: IOwnProps) => {
    const handleLinkClick = (event: MouseEvent<HTMLAnchorElement>) => {
        event.preventDefault();
        window.open(href, "_blank");
    };

    return (
        <a href={href} onClick={handleLinkClick} {...props}>
            {children}
        </a>
    );
};

export default RenderLink;
